import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export type TokenFisicoAlertType = 'error' | 'warning';

export interface TokenFisicoAlertModalData {
  type: TokenFisicoAlertType;
  title: string;
  message: string;
}

@Component({
  selector: 'app-token-fisico-alert-modal',
  templateUrl: './token-fisico-alert-modal.component.html',
  styleUrls: ['./token-fisico-alert-modal.component.css'],
  standalone: false
})
export class TokenFisicoAlertModalComponent {
  readonly type: TokenFisicoAlertType;
  readonly title: string;
  readonly message: string;

  constructor(
    public dialogRef: MatDialogRef<TokenFisicoAlertModalComponent>,
    @Inject(MAT_DIALOG_DATA) data: TokenFisicoAlertModalData
  ) {
    this.type = data?.type ?? 'error';
    this.title = data?.title ?? 'Error';
    this.message = data?.message ?? '';
  }

  get isError(): boolean {
    return this.type === 'error';
  }

  get isWarning(): boolean {
    return this.type === 'warning';
  }

  close(): void {
    this.dialogRef.close();
  }
}
